import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  TabellaCfgDinamicaComponent,
  TabellaDinamica,
} from 'src/app/components/tabella-cfg-dinamica/tabella-cfg-dinamica.component';

@Component({
  selector: 'app-dialog-crea-tabella-dinamica',
  standalone: false,

  templateUrl: './dialog-crea-tabella-dinamica.component.html',
  styleUrl: './dialog-crea-tabella-dinamica.component.scss',
})
export class DialogCreaTabellaDinamicaComponent {
  @ViewChild(TabellaCfgDinamicaComponent) cfgTabella!: TabellaCfgDinamicaComponent;

  /* Probabilemnte il salvataggio sul componente della tabella sarà da eliminare */
  /* forse anche il titolo */

  constructor(
    public dialogRef: MatDialogRef<DialogCreaTabellaDinamicaComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isConfigurazione: boolean;
      tabella: TabellaDinamica | undefined;
    },
  ) {}

  salva() {
    this.dialogRef.close(this.cfgTabella.salva());
  }
}
